module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Shorts-1285286f185ef5bd267f16365c1a5c1b.svg";